// import React, { useEffect, useState } from "react";
// import { updateUserInfos, checkEmailExistence } from "../../../services/params"; // Ajoute la fonction checkEmailExistence
// import { useAuth } from "../../authProvider";
// import { showSuccessToaster } from "../../../Utils/toasters/success";
// import { useTranslation } from "react-i18next";

// function PersonalInfoForm() {
//   const { currentUser, updateCurrentUser } = useAuth();
//   const { t } = useTranslation();

//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState({
//     hasError: false,
//     msg: "",
//     fields: {},
//   });

//   const [formData, setFormData] = useState({
//     firstname: currentUser?.firstname || "",
//     email: currentUser?.email || "",
//     phone: currentUser?.phone || "",
//   });

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));

//     // Clear field-specific error
//     if (errors.fields[name]) {
//       setErrors((prev) => ({
//         ...prev,
//         fields: { ...prev.fields, [name]: "" },
//       }));
//     }
//   };

//   const handleSubmit = async () => {
//     setLoading(true);
//     setErrors({ hasError: false, msg: "", fields: {} });

//     let fieldErrors = {};
//     if (!formData.firstname.trim())
//       fieldErrors.firstname = t("Le nom est requis.");
//     if (!formData.email.trim()) fieldErrors.email = t("L'email est requis.");
//     if (!formData.phone.trim())
//       fieldErrors.phone = t("Le téléphone est requis.");

//     if (Object.keys(fieldErrors).length > 0) {
//       setErrors({
//         hasError: true,
//         msg: t("Veuillez remplir tous les champs obligatoires."),
//         fields: fieldErrors,
//       });
//       setLoading(false);
//       return;
//     }
//     // Vérifier si l'email existe déjà
// const emailExists = await checkEmailExistence(
//   formData.email,
//   currentUser.userId
// );
//     if (emailExists) {
//       setErrors({
//         hasError: true,
//         msg: t("Cet email est déjà utilisé. Veuillez en choisir un autre."),
//         fields: { email: t("Email déjà utilisé") },
//       });
//       setLoading(false);
//       return;
//     }
//     const res = await updateUserInfos(currentUser?.userId, formData);
// console.log("response from updateUserInfos", res);

//  if (!res || !res.user) {
//    setErrors({
//      hasError: true,
//      msg: res?.message || t("Une erreur est survenue"),
//      fields: {},
//    });
//    setLoading(false);
//    return;
//  }
//     updateCurrentUser({
//       firstname: formData.firstname,
//       phone: formData.phone,
//       email: formData.email,
//     });

// showSuccessToaster(res.message || "Succès !!");
//     setLoading(false);
//   };
//   useEffect(() => {
//     showSuccessToaster("Test Toaster");
//   }, []);

//   return (
//     <>
//       <div className="input-group">
//         <label htmlFor="firstname">{t("name")}</label>
//         <input
//           id="firstname"
//           name="firstname"
//           type="text"
//           className="form-control"
//           value={formData.firstname}
//           onChange={handleInputChange}
//           required
//         />
//         {errors.fields.firstname && (
//           <small className="text-danger">{errors.fields.firstname}</small>
//         )}
//       </div>

//       <div className="input-group">
//         <label htmlFor="email">{t("email")}</label>
//         <input
//           id="email"
//           name="email"
//           type="email"
//           className="form-control"
//           value={formData.email}
//           onChange={handleInputChange}
//           required
//         />
//         {errors.fields.email && (
//           <small className="text-danger">{errors.fields.email}</small>
//         )}
//       </div>

//       <div className="input-group">
//         <label htmlFor="phone">{t("phone")}</label>
//         <input
//           id="phone"
//           name="phone"
//           type="text"
//           className="form-control"
//           value={formData.phone}
//           onChange={handleInputChange}
//           required
//         />
//         {errors.fields.phone && (
//           <small className="text-danger">{errors.fields.phone}</small>
//         )}
//       </div>

//       <br />
//       <div className="save-btn-container">
//         <div className="error-msg d-flex justify-content-center">
//           {errors.hasError && errors.msg && <p>{errors.msg}</p>}
//         </div>
//         <button
//           className="tab-btn-submit"
//           onClick={handleSubmit}
//           disabled={loading}
//         >
//           {t("Enregistrer")}
//         </button>
//       </div>
//     </>
//   );
// }

// export default PersonalInfoForm;
import React, { useState } from "react";
import { showSuccessToaster } from "../../../Utils/toasters/success";
import { updateUserInfos, checkEmailExistence } from "../../../services/params";
import { useAuth } from "../../authProvider";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import toastify styles

function PersonalInfoForm() {
  const { currentUser, updateCurrentUser } = useAuth();
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    hasError: false,
    msg: "",
    fields: {},
  });

  const [formData, setFormData] = useState({
    firstname: currentUser?.firstname || "",
    email: currentUser?.email || "",
    phone: currentUser?.phone || "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear field-specific error
    if (errors.fields[name]) {
      setErrors((prev) => ({
        ...prev,
        fields: { ...prev.fields, [name]: "" },
      }));
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    setErrors({ hasError: false, msg: "", fields: {} });

    let fieldErrors = {};
    if (!formData.firstname.trim())
      fieldErrors.firstname = t("Le nom est requis.");
    if (!formData.email.trim()) fieldErrors.email = t("L'email est requis.");
    if (!formData.phone.trim())
      fieldErrors.phone = t("Le téléphone est requis.");

    if (Object.keys(fieldErrors).length > 0) {
      setErrors({
        hasError: true,
        msg: t("Veuillez remplir tous les champs obligatoires."),
        fields: fieldErrors,
      });
      setLoading(false);
      return;
    }

    // Vérifier si l'email existe déjà
    const emailExists = await checkEmailExistence(
      formData.email,
      currentUser.userId
    );
    if (emailExists) {
      setErrors({
        hasError: true,
        msg: t("Cet email est déjà utilisé. Veuillez en choisir un autre."),
        fields: { email: t("Email déjà utilisé") },
      });
      setLoading(false);
      return;
    }

    const res = await updateUserInfos(currentUser?.userId, formData);
    console.log("Réponse de updateUserInfos:", res);

    if (!res.success) {
      setErrors({
        hasError: true,
        msg: res.message || t("Une erreur est survenue"),
        fields: {},
      });
      setLoading(false);
      return;
    }

    updateCurrentUser({
      firstname: formData.firstname,
      phone: formData.phone,
      email: formData.email,
    });

    console.log("Calling showSuccessToaster"); // Confirm that it's called
    showSuccessToaster(res.message || "Succès !!");
    setLoading(false);
  };

  return (
    <>
      <div className="input-group">
        <label htmlFor="firstname">{t("Nom")}</label>
        <input
          id="firstname"
          name="firstname"
          type="text"
          className="form-control"
          value={formData.firstname}
          onChange={handleInputChange}
          required
        />
        {errors.fields.firstname && (
          <small className="text-danger">{errors.fields.firstname}</small>
        )}
      </div>

      <div className="input-group">
        <label htmlFor="email">{t("email")}</label>
        <input
          id="email"
          name="email"
          type="email"
          className="form-control"
          value={formData.email}
          onChange={handleInputChange}
          required
        />
        {errors.fields.email && (
          <small className="text-danger">{errors.fields.email}</small>
        )}
      </div>

      <div className="input-group">
        <label htmlFor="phone">{t("Téléphone")}</label>
        <input
          id="phone"
          name="phone"
          type="text"
          className="form-control"
          value={formData.phone}
          onChange={handleInputChange}
          required
        />
        {errors.fields.phone && (
          <small className="text-danger">{errors.fields.phone}</small>
        )}
      </div>

      <br />
      <div className="save-btn-container">
        <div className="error-msg d-flex justify-content-center">
          {errors.hasError && errors.msg && <p>{errors.msg}</p>}
        </div>
        <button
          className="tab-btn-submit"
          onClick={handleSubmit}
          disabled={loading}
        >
          {t("Enregistrer")}
        </button>
      </div>

      {/* ToastContainer should be in the root component, so it's rendered once */}
      <ToastContainer />
    </>
  );
}

export default PersonalInfoForm;
